import React, {Component} from 'react';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import {Button} from '@material-ui/core';

class ResetSent extends Component {
    constructor(props) {
        super(props);
        globalProps = props;
    }

    render() {
        return (
            <div className="login-background">
                <MuiThemeProvider>
                    <img src={require('../../JXB Logo.png')} alt="JXB Performance" style={{width: 200, margin: '20px auto 0'}} />
                    <div className="container" style={{maxWidth: 400, marginTop: 20, padding: '25px 10px'}}>
                        <div>
                            <h1 style={{margin: '0 auto 20px'}}>JXB Performance Password Reset</h1>
                            <h3>Check your email inbox for a link to reset your password! This link expires in 60 minutes.</h3>
                            <Button onClick={() => {globalProps.history.push('/login')}} className="success-button-lg">Back to Login</Button>
                        </div>
                        <br />
                        <center>&#9400; {new Date().getFullYear()} JXB Performance, All rights reserved.</center>
                    </div>
                </MuiThemeProvider>
            </div>
        );
    }
}

let globalProps;

export default ResetSent;
